export const INVITE_STEPS = {
  // CHECK_PHONE_NUMBER: "CHECK_PHONE_NUMBER",
  SELECT_PROJECT: "SELECT_PROJECT",
  SELECT_ROLE: "SELECT_ROLE",
  SELECT_TEAM: "SELECT_TEAM",
  SHOW_PROJECT_USER: "SHOW_PROJECT_USER",
  MANAGER_ACCESS: "MANAGER_ACCESS"
};

export const SELECT_TEAM_MODES = {
  ADD_NEW_CUSTODIAN: "ADD_NEW_CUSTODIAN",
  ADD_NEW_MANAGER: "ADD_NEW_MANAGER",
  ADD_NEW_TEAM_TO_CUSTODIAN: "ADD_NEW_TEAM_TO_CUSTODIAN",
  CONVERT_ADMIN_TO_MANAGER: "CONVERT_ADMIN_TO_MANAGER",
  REACTIVATE_MANAGER: "REACTIVATE_MANAGER",
  ADD_NEW_TEAM_TO_MANAGER: "ADD_NEW_TEAM_TO_MANAGER"
};

export const MANAGER_ACCESS_MODES = {
  ADD_NEW_MANAGER: "ADD_NEW_MANAGER",
  CONVERT_ADMIN_TO_MANAGER: "CONVERT_ADMIN_TO_MANAGER",
  REACTIVATE_MANAGER: "REACTIVATE_MANAGER",
  ADD_NEW_TEAM_TO_MANAGER: "ADD_NEW_TEAM_TO_MANAGER",
  EDIT_MANAGER_ACCESS: "EDIT_MANAGER_ACCESS"
};

const getCompleteKey = (key, completeKey) => {
  if (completeKey) {
    return `${key}_permission`;
  }
  return key;
};
export const TEAM_PERMISSIONS = completeKey => {
  return {
    ACCOUNT_TITLE: getCompleteKey("account_title", completeKey),
    COST_CENTER: getCompleteKey("cost_center", completeKey),
    HASHTAG: getCompleteKey("hashtag", completeKey),
    CONTACT: getCompleteKey("contact", completeKey),
    ADMIN_TRANSACTION_ADD: getCompleteKey("admin_transaction_add", completeKey),
    ADMIN_TRANSACTION_EDIT: getCompleteKey(
      "admin_transaction_edit",
      completeKey
    ),
    ADMIN_TRANSACTION_DELETE: getCompleteKey(
      "admin_transaction_delete",
      completeKey
    ),
    IMPREST_FINALIZED: getCompleteKey("imprest_finalized", completeKey)
  };
};
export const MANAGER_BASE_INFO_FIELDS = [
  TEAM_PERMISSIONS().ACCOUNT_TITLE,
  TEAM_PERMISSIONS().COST_CENTER,
  TEAM_PERMISSIONS().HASHTAG,
  TEAM_PERMISSIONS().CONTACT
];
export const MANAGER_ADMIN_TRANSACTION_MANAGEMENT_FIELDS = [
  TEAM_PERMISSIONS().ADMIN_TRANSACTION_ADD,
  TEAM_PERMISSIONS().ADMIN_TRANSACTION_EDIT,
  TEAM_PERMISSIONS().ADMIN_TRANSACTION_DELETE
];

export const MANAGER_ACCESS_SETTING = [
  {
    key: "base_info",
    value: "مدیریت اطلاعات پایه",
    info:
      "با این سطح دسترسی، مدیر مربوطه امکان ایجاد، ویرایش و حذف سرفصل‌حساب‌ها، مرکز هزینه‌ها، هشتگ‌ها و طرف حساب‌ها را خواهد داشت.",
    type: "bool",
    equivalentKey: getCompleteKey(MANAGER_BASE_INFO_FIELDS[0], true)
  },
  {
    key: "imprest_finalized",
    value: "امکان قطعی کردن تنخواه‌های ارسالی",
    info:
      "با این سطح دسترسی، مدیر مربوطه امکان قطعی کردن تنخواه‌های ارسال شده به تیم‌های تنخواه‌داری مدیر مربوطه را خواهد داشت. با قطعی شدن یک تنخواه امکان ویرایش و حذف آن تنخواه وجود نخواهد داشت.",
    type: "bool",
    equivalentKey: TEAM_PERMISSIONS(true).IMPREST_FINALIZED
  },
  {
    key: "admin_transaction_management",
    value: "امکان ثبت و ویرایش تراکنش‌های تنخواه‌داران",
    info:
      "با این سطح دسترسی، مدیر مربوطه امکان ثبت، ویرایش و حذف تراکنش‌ها را در تیم‌های تنخواه‌داری مدیر مربوطه خواهد داشت.",
    type: "bool",
    equivalentKey: getCompleteKey(
      MANAGER_ADMIN_TRANSACTION_MANAGEMENT_FIELDS[0],
      true
    )
  }
];

export const TEAM_SUB_ITEM = {
  ACCOUNT_TITLE: { name: "سرفصل‌حساب‌ها", type: 1 },
  COST_CENTER: { name: "مراکز هزینه", type: 2 },
  CONTACT: { name: "طرف حساب‌ها", type: 4 },
  HASHTAG: { name: "هشتگ‌ها", type: 3 }
};

export const SINGULAR_TEAM_SUB_ITEM = {
  ACCOUNT_TITLE: { name: "سرفصل‌حسابی", type: 1 },
  COST_CENTER: { name: "مرکز هزینه‌ای", type: 2 },
  HASHTAG: { name: "هشتگی", type: 3 },
  CONTACT: { name: "طرف حسابی", type: 4 }
};
